import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8a35ab34"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "prompt-content"
};
var _hoisted_2 = {
  "class": "prompt-title fsb"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "line"
  }, null, -1);
});
var _hoisted_5 = {
  "class": "prompt-desc"
};
var _hoisted_6 = {
  "class": "prompt-btn flex-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");
  var _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_popup, {
    show: $data.visible,
    "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
      return $data.visible = $event;
    }),
    round: ""
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString($props.title ? $props.title : _ctx.$t("publish.prompt")), 1), _createElementVNode("img", {
        "class": "pop-close",
        src: require('@/assets/image/commom/icon_close_popup.png'),
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.handleCancle && $options.handleCancle.apply($options, arguments);
        })
      }, null, 8, _hoisted_3)]), _hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($props.description), 1), _renderSlot(_ctx.$slots, "default", {}, undefined, true), _createElementVNode("div", _hoisted_6, [$props.type == 0 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        "class": "cancle",
        onClick: $options.handleCancle
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("publish.cancle")), 1)];
        }),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        "class": "confirm",
        color: "#000",
        loading: $data.loading,
        onClick: $options.handleConfirm
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("publish.confirm")), 1)];
        }),
        _: 1
      }, 8, ["loading", "onClick"])])])];
    }),
    _: 3
  }, 8, ["show"])]);
}